/**
 * @desc 上传报关附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: Array<defs.tms.UploadDeclarationFilesRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/uploadDeclarationFiles`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
